import { useEffect } from "react";
import Select from "react-select";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? "1px solid #AF7ABA" : "",
    borderRadius: "8px",
    boxShadow: state.isFocused ? "0px 0px 0px 4px #F4EBFF" : "0 0 10px 4px rgba(225, 225, 225, 0.5)",
    "&:hover": {
      border: "1px solid none",
    },
    padding: "2px",
    minHeight: "44px",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#5A1E6680" : null,
    color: "#344054",
    fontSize: "14px",
    padding: "16px",
    fontWeight: "semibold",
    borderBottomColor: "#EAECF0",
    borderBottomWidth: "1px",
    "&:hover": {
      backgroundColor: "#5A1E6690",
      color: "white",
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#FFFFFF80",
    borderRadius: "4px",
    marginRight: "6px",
    border: "1px solid #D0D5DD",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#344054",
    fontSize: "14px",
    fontWeight: "medium",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#00000080",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#00000080",
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#344054",
  }),
};

export const MultiSelectChipsWithSearchDropdown = (props) => {
  const {
    label,
    placeholder,
    errorMsg,
    onChange,
    options = [
      { value: "apple", label: "Apple" },
      { value: "banana", label: "Banana" },
      { value: "orange", label: "Orange" },
      { value: "grape", label: "Grape" },
      { value: "melon", label: "Melon" },
    ],
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    maxSelectionAllowed = 15,
    defaultSelectedOptions = [],
    onShowError,
  } = props || {};

  const selectedOptions = options.filter(option =>
    defaultSelectedOptions.includes(option.label)
  );

  const handleChange = (selectedValues) => {
    if (selectedValues?.length <= maxSelectionAllowed) {
      onChange?.(selectedValues);
    } else {
      onShowError?.(false);
    }
  };

  return (
    <div className={`${width}`}>
      {!!label && (
        <div className="mb-0.5">
          <span className="text-gray-700 font-medium text-sm">{label}</span>
        </div>
      )}
      <Select
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        placeholder={placeholder}
        isSearchable
        styles={customStyles}
      />
      {!!errorMsg && (
        <span className="text-red font-medium text-sm mt-1 pt-2">
          {errorMsg}
        </span>
      )}
    </div>
  );
};
